<template>
  <div style="width:100%;height:100%;">
    <div class="userratio">
      <div class="top">
        <div
          class="left"
          v-for="(item,index) in arr"
          :class="[{'dianji': arrkey==item}]"
          :key="index"
          @click="cutkey(item)"
        >{{item}}</div>
      </div>
      <div class="bottom">
        <div id="echarts32" :style="charts32Style"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts32",
  props: {
    charts32Style: {
      type: Object,
      default: () => {
        return { width: "100%", height: "100%", position: "relative" };
      }
    },
    echares32Data: {
      type: Array,
      default: () => {
        return [
          { value: 20, name: "执行中" },
          { value: 30, name: "待执行" },
          { value: 50, name: "已完成" },
          { value: 15, name: "空" }
        ];
      }
    }
  },
  data() {
    let arr = ["货位标记", "货位状态"];
    let tabData = ["库区", "巷道", "货位"];
    return {
      arr: arr,
      arrkey: arr[0],
      tabData: tabData,
      tabKey: tabData[0],
      // echares32Data:[]
    };
  },
  mounted() {
    this.pies();
    // this.getHwztList();
  },

  methods: {
    getHwztList() {   //  货位状态
      let self = this;
      self.echares32Data = [];
      let url = '/api/DataStatistical/ShelfGrid_StateRto';
      this.$handleRequest(window.ApiHost1+url, {
        "WareHouseCode": window.PYKWareHouseCode,
      }, 'post', function(res) {  //success
        console.log("货位状态====================")
        console.log(res)
        var list = res.retData.Rows;
        for (var i = 0; i < list.length; i++) {
          let text = {
            value: list[i].Count,
            name: list[i].ShelfGridStateName,
          };
          self.echares32Data.push(text);
        }
        console.log(self.echares32Data);
      }, function(res) {  //fail
        console.log('--fail--', res)
      });
    },
    //大选项卡
    cutkey(item) {
      this.arrkey = item;
      this.$emit("echarts32key", item);
    },
    //小选项卡
    tabSwitch(item) {
      //   console.log(item);
      this.tabKey = item;
      //   this.getGzsjhzList();
      this.$emit("receive32data", item);
    },
    //echarts图表
    pies() {
      var _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("echarts32")
      );
      var colors = ["#375CF9", "#F52282", "#1EDECE", "#FEAD1C"];
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },

        series: [
          {
            // name: "当日订单占比",
            type: "pie",
            radius: ["40%", "55%"],
            center: ["50%", "62%"],
            itemStyle: {
              // normal: {
              //   borderWidth: 5,
              //   borderColor: "#D8BFD8"
              // }
            },
            //  roseType: "area",   //设置不规则饼图
            color: [
              {
                type: "radial",
                x: 0.4,
                y: 0.8,
                r: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#375CF9" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(27, 40, 208, .8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              {
                type: "radial",
                x: 0.6,
                y: 0.4,
                r: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#F52282" // 0% 处的颜色
                  },
                  {
                    offset: 1,

                    color: "rgba(133, 40, 220, .8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              {
                type: "radial",
                x: 0.2,
                y: 0.5,
                r: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#1EDECE" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 232, 118, .8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              {
                type: "radial",
                x: 0.2,
                y: 0.5,
                r: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#FEAD1C" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(249, 54, 45, .8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            ],
            label: {
              normal: {
                position: "left",
                formatter: "{d}% \n{b}",
                color: "#000",
                fontSize: "16",
                align: "right"
              }
            },
            data: _this.echares32Data
          }
        ]
      };
      behaviorpie.setOption(option);
    }
  }
};
</script>
<style scoped>
.userratio {
  /* width: 374px;
  height: 340px; */
  width: 100%;
  height: 100%;
  position: relative;
}
.top {
  height: 38px;
  width: 100%;
  /* box-shadow: inset 2px  #065457 */
  display: flex;
  /* border:  3px  solid #009585 */
}
.left {
  width: 50%;
  height: 34px;
  background: #072132;
  /* border: 2px solid #009585; */
  line-height: 32px;
  color: #1edecf;
  text-align: center;
}
.dianji {
  background: #01665e;
  color: #fff;
}
.bottom {
  width: 100%;
  height: calc(100% - 38px);
}
.tab-switch {
  width: 240px;
  height: 30px;
  position: absolute;
  right: 40px;
  top: 56px;
}
.tab-switch span {
  color: #fff;
  font-size: 14px;
  text-align: center;
  width: 40px;
  padding: 3px;
  margin: 0px 10px;
  line-height: 24px;
  height: 24px;
  display: inline-block;
  background-color: #1b406d;
  border-radius: 3px;
  cursor: pointer;
}
.current {
  background: #07afa0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts32.vue